import { render, staticRenderFns } from "./LevelReviewRegistration.vue?vue&type=template&id=ab1c39dc&"
import script from "./LevelReviewRegistration.vue?vue&type=script&lang=ts&"
export * from "./LevelReviewRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./LevelReviewRegistration.vue?vue&type=style&index=0&id=ab1c39dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports